import { render, staticRenderFns } from "./BatchCard.vue?vue&type=template&id=ae752b98&scoped=true"
import script from "./BatchCard.vue?vue&type=script&lang=js"
export * from "./BatchCard.vue?vue&type=script&lang=js"
import style0 from "./BatchCard.vue?vue&type=style&index=0&id=ae752b98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae752b98",
  null
  
)

export default component.exports